export default __webpack_public_path__ + "asset/wales.842a7dee0e44f834f139a2e071943981.svg";